class cartRegister {

    static storage = {};

    static setStrategy(data){
        let storage = cartRegister.getCheckout();
        storage.strategy = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setStrategyTab(data){
        let storage = cartRegister.getCheckout();
        storage.strategy_tab = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setDisplayRegion(data){
        let storage = cartRegister.getCheckout();
        storage.display_region = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setVideoAd(data){
        let storage = cartRegister.getCheckout();
        storage.video = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setKeywordLanguages(data){
        let storage = cartRegister.getCheckout();
        storage.keyword_languages = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setCrossRoadOption(data){
        let storage = cartRegister.getCheckout();
        storage.crossroad = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setOptions(data){
        let storage = cartRegister.getCheckout();
        storage.options = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdIndustry(data){
        let storage = cartRegister.getCheckout();
        storage.industry = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdImage(data){
        let storage = cartRegister.getCheckout();
        storage.image = data;
        storage.admin_image = null;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdminVideo(data){
        let storage = cartRegister.getCheckout();
        storage.admin_video = data.url;
        storage.admin_video_thumbnail = data.thumbnail;
        //storage.image = null;
        try {
            cartRegister.storage = storage;
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdminSlideshow(data){
        let storage = cartRegister.getCheckout();
        storage.admin_slideshow_images = data?data:[];
        try {
            cartRegister.storage = storage;
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdAdminImage(data){
        let storage = cartRegister.getCheckout();
        storage.admin_image = data;
        storage.image = null;
        try {
            cartRegister.storage = storage;
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdUploadedImages(data){
        let storage = cartRegister.getCheckout();
        storage.uploaded_images = data;
        try {
            cartRegister.storage = storage;
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdQuotes(data){
        let storage = cartRegister.getCheckout();
        storage.quotes = data;
        storage.admin_quotes = null;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdAdminQuotes(data){
        let storage = cartRegister.getCheckout();
        storage.admin_quotes = data;
        storage.quotes = null;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdChannels(data){
        let storage = cartRegister.getCheckout();
        storage.channels = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdMarket(data){
        let storage = cartRegister.getCheckout();
        storage.market = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdLanguage(data){
        let storage = cartRegister.getCheckout();
        storage.language = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdCurrency(data){
        let storage = cartRegister.getCheckout();
        storage.currency = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setSelectedIndustries(data){
        let storage = cartRegister.getCheckout();
        storage.selected_industries = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdRelatedIndustries(data){
        let storage = cartRegister.getCheckout();
        storage.related_industries = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdRegions(data){
        let storage = cartRegister.getCheckout();
        storage.regions = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdRegionsGrid(data){
        let storage = cartRegister.getCheckout();
        storage.regions_grid = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdDuration(data){
        let storage = cartRegister.getCheckout();
        storage.duration = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdSpend(data){
        let storage = cartRegister.getCheckout();
        storage.spend = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdImpressions(data){
        let storage = cartRegister.getCheckout();
        storage.impressions = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdClicks(data){
        let storage = cartRegister.getCheckout();
        storage.clicks = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdSmartSpend(data){
        let storage = cartRegister.getCheckout();
        storage.smart_spend = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAvailableBudget(data){
        let storage = cartRegister.getCheckout();
        storage.budget = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static removeBudget(data){
        let storage = cartRegister.getCheckout();
        delete storage.budget;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdPlan(data){
        let storage = cartRegister.getCheckout();
        storage.plan = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdPlans(data){
        let storage = cartRegister.getCheckout();
        storage.plans = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdTargets(data){
        let storage = cartRegister.getCheckout();
        storage.targets = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdAgeRange(data){
        let storage = cartRegister.getCheckout();
        storage.age_range = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdCompanyName(data){
        let storage = cartRegister.getCheckout();
        storage.company_name = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdWebsite(data){
        let storage = cartRegister.getCheckout();
        storage.website = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdlandingPage(data){
        let storage = cartRegister.getCheckout();
        storage.landingpage = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdPhone(data){
        let storage = cartRegister.getCheckout();
        storage.phone = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdShowPhone(data){
        let storage = cartRegister.getCheckout();
        storage.show_phone = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdLockin(data){
        let storage = cartRegister.getCheckout();
        storage.lockin = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdLockinPlan(data){
        let storage = cartRegister.getCheckout();
        storage.lockin_plan = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setUserEmail(data){
        let storage = cartRegister.getCheckout();
        storage.email = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setOfferServiceFeeFixed(data){
        let storage = cartRegister.getCheckout();
        storage.servicefee_fixed = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setOfferServiceFeePercentage(data){
        let storage = cartRegister.getCheckout();
        storage.servicefee_percentage = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setLockInPlans(data){
        let storage = cartRegister.getCheckout();
        storage.lockin_plans = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdExtraIndustries(data){
        let storage = cartRegister.getCheckout();
        storage.extra_industries = data;
        console.log(storage);
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setFacebookInterests(data){
        let storage = cartRegister.getCheckout();
        storage.interests = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setFacebookBehaviors(data){
        let storage = cartRegister.getCheckout();
        storage.behaviors = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static setAdTargetSlogans(data){
        let storage = cartRegister.getCheckout();
        storage.target_slogans = data;
        try {
            sessionStorage.setItem('storage', JSON.stringify(storage));
        }catch (e) {
            cartRegister.storage = storage;
        }
    }

    static getCheckout(){
        if(Object.keys(cartRegister.storage).length !== 0 && cartRegister.storage.constructor === Object){
            return cartRegister.storage;
        }else{
            let storage = {};
            try {
                storage = JSON.parse(sessionStorage.getItem('storage'));
            }catch (e) {
                storage = cartRegister.storage;
            }
            if(storage){
                return storage;
            }else{
                return {};
            }
        }
    }

    static removeCheckout(){
        cartRegister.storage = {};
        try{
            sessionStorage.removeItem('storage');
        }catch (e) {}
    }

    //SHORTENER
    static setCrossRoad(data){
        cartRegister.setCrossRoadOption(data);
    }

    static setIndustry(data){
        cartRegister.setAdIndustry(data);
    }

    static setImage(data){
        cartRegister.setAdImage(data);
    }

    static setAdminImage(data){
        cartRegister.setAdAdminImage(data);
    }

    static setUploadedImages(data){
        cartRegister.setAdUploadedImages(data);
    }

    static setQuotes(data){
        cartRegister.setAdQuotes(data);
    }

    static setAdminQuotes(data){
        cartRegister.setAdAdminQuotes(data);
    }

    static setChannels(data){
        cartRegister.setAdChannels(data);
    }

    static setMarket(data){
        cartRegister.setAdMarket(data);
    }

    static setLang(data){
        cartRegister.setAdLanguage(data);
    }

    static setCurrency(data){
        cartRegister.setAdCurrency(data);
    }

    static setRelated(data){
        cartRegister.setAdRelatedIndustries(data);
    }

    static setRegions(data){
        cartRegister.setAdRegions(data);
    }

    static setRegionsGrid(data){
        cartRegister.setAdRegionsGrid(data);
    }

    static setDuration(data){
        cartRegister.setAdDuration(data);
    }

    static setSpend(data){
        cartRegister.setAdSpend(data);
    }

    static setImpressions(data){
        cartRegister.setAdImpressions(data);
    }

    static setClicks(data){
        cartRegister.setAdClicks(data);
    }

    static setSmartSpend(data){
        cartRegister.setAdSmartSpend(data);
    }

    static setBudget(data){
        cartRegister.setAvailableBudget(data);
    }

    static setPlan(data){
        cartRegister.setAdPlan(data);
    }

    static setPlans(data){
        cartRegister.setAdPlans(data);
    }

    static setTargets(data){
        cartRegister.setAdTargets(data);
    }

    static setAgeRange(data){
        cartRegister.setAdAgeRange(data);
    }

    static setCompanyName(data){
        cartRegister.setAdCompanyName(data);
    }

    static setWebsite(data){
        cartRegister.setAdWebsite(data);
    }

    static setLandingpage(data){
        cartRegister.setAdlandingPage(data);
    }

    static setPhone(data){
        cartRegister.setAdPhone(data);
    }

    static setLockin(data){
        cartRegister.setAdLockin(data);
    }

    static setLockinPlan(data){
        cartRegister.setAdLockinPlan(data);
    }

    static setEmail(data){
        cartRegister.setUserEmail(data);
    }

    static setServiceFeeFixed(data){
        cartRegister.setOfferServiceFeeFixed(data);
    }

    static setServiceFeePercentage(data){
        cartRegister.setOfferServiceFeePercentage(data);
    }

    static lockinPlans(data){
        cartRegister.setLockInPlans(data);
    }

    static setExtraIndustries(data){
        cartRegister.setAdExtraIndustries(data);
    }

    static setInterests(data){
        cartRegister.setFacebookInterests(data);
    }

    static setBehaviors(data){
        cartRegister.setFacebookBehaviors(data);
    }

    static setTargetSlogans(data){
        cartRegister.setAdTargetSlogans(data);
    }

    static get(){
        return cartRegister.getCheckout();
    }

    static remove(){
        cartRegister.removeCheckout();
    }

}

export {cartRegister}


// WEBPACK FOOTER //
// ./src/services/cartRegister.js